<template>
    <div>
        <div class="ix-checking-form">
            <div class="ix-checking-form-step" v-bind:class="{ active: step == 1 }">
                <div class="ix-checking-form-step-left">
                    <h2 class="ix-checking-form-step-title">1. <span class="ix-checking-form-step-name">Salariés</span></h2>
                     <div class="ix-checking-form-step-content">
                        <div v-show="step == 1">
                            <div class="ix-table-box">
                                <table class="ix-table">
                                    <tbody>
                                        <tr v-if="users.length == 0">
                                            <td colspan="100%">Aucun salarié sélectionné</td>
                                        </tr>
                                        <tr v-for="(user, index) in users" :key="index">
                                            <td>
                                                <span class="ix-avatar xsm">
                                                    <img :src="user.avatar_path" v-if="user.avatar_path">
                                                    <span v-if="!user.avatar_path">{{ user.initial }}</span>
                                                </span>
                                                {{ user.fullname }}
                                                <input type="hidden" :name="'users[' + index + '][id]'" v-model="user.id">
                                                <input type="hidden" :name="'users[' + index + '][fullname]'" v-model="user.fullname">
                                                <input type="hidden" :name="'users[' + index + '][avatar_path]'" v-model="user.avatar_path">
                                                <input type="hidden" :name="'users[' + index + '][initial]'" v-model="user.initial">
                                            </td>
                                            <td class="text-right" v-if="canSelectUsers">
                                                <button type="button" class="btn btn-sm transparent" @click="deleteUserRow(index)">
                                                    <i class="far fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        <tr v-if="canSelectUsers">
                                            <td colspan="100%">
                                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="userSearchInput" type="text" v-model="user">
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <button class="ix-btn ix-btn-small ix-btn-block blue mt-4" type="button" @click="goToStep(2)">Continuer</button>
                        </div>
                        <div v-show="step != 1">
                            <span v-if="users.length == 0">Aucun salarié sélectionné</span>
                            <div class="d-inline-block" v-for="(user, index) in users" :key="index">
                                <span class="ix-avatar xsm">
                                    <img :src="user.avatar_path" v-if="user.avatar_path">
                                    <span v-if="!user.avatar_path">{{ user.initial }}</span>
                                </span>

                                {{ user.fullname }}
                                &nbsp;
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ix-checking-form-step-right"  v-if="step != 1">
                    <button class="ix-btn ix-btn-small ix-btn-icon" type="button" @click="goToStep(1)">
                        <i class="far fa-pen"></i>
                    </button>
                </div>
            </div>

             <div class="ix-checking-form-step" v-bind:class="{ active: step == 2 }">
                <div class="ix-checking-form-step-left">
                    <h2 class="ix-checking-form-step-title">2. <span class="ix-checking-form-step-name">Dates</span></h2>

                    <div class="ix-checking-form-step-content">
                        <div v-show="step == 2">
                            <div class="input-group mb-2" v-for="(date, index) in dates" :key="date.uniq">
                                <div class="ix-datepicker-wrapper">
                                    <input type="text" class="form-control checking-datepicker" placeholder="jj/mm/aaaa" :id="'datepicker' + date.uniq" v-model="date.day" name="dates[]">
                                </div>
                                <div class="input-group-append">
                                    <button class="ix-btn ix-btn-icon" type="button" @click="deleteDateRow(index)"><i class="far fa-trash"></i></button>
                                </div>
                            </div>

                            <button type="button" class="ix-btn link" @click="addDate('')"><i class="far fa-plus"></i> Ajouter une date</button>

                            <button class="ix-btn ix-btn-small ix-btn-block blue mt-4" type="button" @click="goToStep(3)">Continuer</button>
                        </div>
                        <div v-show="step != 2">
                            <span v-if="dates.length == 0">Aucune date sélectionnée</span>
                            <span v-if="dates.length > 0">
                                {{ dates.map(date => date.day).join(', ') }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="ix-checking-form-step-right" v-if="step != 2">
                    <button class="ix-btn ix-btn-small ix-btn-icon" type="button" @click="goToStep(2)">
                        <i class="far fa-pen"></i>
                    </button>
                </div>
            </div>


            <div class="ix-checking-form-step" v-bind:class="{ active: step == 3 }">
                <div class="ix-checking-form-step-left">
                    <h2 class="ix-checking-form-step-title">3. <span class="ix-checking-form-step-name">Ordre de travail</span></h2>
                    <div class="ix-checking-form-step-content mt-4" v-show="step == 3">
                         <div class="ix-table-box mb-3" v-if="currentInspection && currentInspection != null">
                            <table class="ix-table">
                                <thead>
                                    <tr>
                                        <th>Ordre de travail</th>
                                         <th>Début</th>
                                        <th>
                                            Durée 
                                        </th>
                                        <th>Dont heures de nuit</th>
                                        <th>Temps de route</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(object, index) in objects" :key="index">
                                        <td>
                                            <span class="ix-text-bold" v-html="truncate(currentInspection.designation, 50)"></span>
                                        </td>
                                        <td>
                                            <input type="time" class="form-control" style="width: 110px;" v-model="object.start_time" required :name="'objects[' + index + '][start_time]'">
                                        </td>
                                         <td>
                                            <input type="time" class="form-control" style="width: 110px;" v-model="object.duration" required name="duration">
                                        </td>
                                        <td>
                                            <input type="time" class="form-control" style="width: 110px;" v-model="object.night" required :name="'objects[' + index + '][night]'">
                                        </td>
                                        <td>
                                            <input type="time" class="form-control" style="width: 110px;" v-model="object.route" required :name="'objects[' + index + '][route]'">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                         </div>
                    </div>
                </div>
            </div>

             <div class="form-check mt-4 mb-4" v-if="canValid">
                <input type="checkbox" v-model="validate" name="validate" value="1" id="validate">
                <label class="form-check-label" for="validate">
                    Validation automatique

                    <span class="ix-text-small ix-text-secondary">(Les pointages générés ne seront pas modifiables)</span>
                </label>
            </div>
        </div>
         <div class="ix-form-actions">
            <div class="ix-form-actions-left">
                <a :href="interventionRoute" class="ix-btn transparent">Retourner sur l'intervention</a>
            </div>
            <div class="ix-form-actions-right">
                <button class="ix-btn green" type="submit" :disabled="isFormValid() == false">Enregistrer</button>
            </div>
        </div>
    </div>
</template>

<script>



export default {
    name: 'CheckingMaintenanceForm',
    props: ['usersRoute','oldData','initialData','canValid','canSelectUsers','canSelectAllUsers','interventionRoute','inspection'],
    
    data(){
        return {
            step: 1,
            dates: [],
            users: [],
            objects: [],
            description: '',
            user: null,
            currentInspection: null,
            duration: null,
            validate: this.canValid ? 1 : 0,
            checking: {
                inspection: null,
            },
        }
    },
    methods: {
        nextStep: function() {
                this.step ++
        },
        goToStep: function(step) {
            if (this.step == 2) {
                this.dates = this.dates.filter(date => { return date.day != null && date.day != '' })
            }

            this.step = step
        },
        isFormValid: function(){
            var countErrorsInDates = this.dates.filter(date => { return date.day == null || date.day == '' }).length
            return  this.users.length > 0 && this.dates.length > 0 && countErrorsInDates == 0 && this.duration != '' && this.duration != null
        },
        // Users
        addUserRow: function (user) {
            if (this.getCurrentSelectedUsersId().includes(user.id) == false) {
                this.users.push(user)
            }
        },
        deleteUserRow: function (index) {
            this.users.splice(index, 1)
        },
        getCurrentSelectedUsersId: function() {
            return this.users.map(user => user.id);
        },
         // Dates
        getCurrentSelectedDates: function() {
            return this.dates.map((date) => {return date.day });
        },
        setDisabledDates: function() {
            var dates = this.getCurrentSelectedDates()
            
            this.dates.forEach((date) => {
                $('#datepicker' + date.uniq).datepicker('setDatesDisabled', dates)
            })
        },
        addDate: function(date) {
            var uniq = Math.random().toString(36).substr(2, 9)
            var currentSelectedDates = this.getCurrentSelectedDates()

            this.dates.push({
                uniq: uniq,
                day: date
            })
            
            setTimeout(() => {
                $("#datepicker" + uniq).datepicker({
                    format: "dd/mm/yyyy",
                    todayBtn: true,
                    language: "fr",
                    calendarWeeks: true,
                    autoclose: true,
                    todayHighlight: true,
                    clearBtn: false,
                    startDate: this.dateStart,
                    endDate: this.dateEnd,
                    datesDisabled: currentSelectedDates
                }).on('changeDate', function(e) {
                    // TODO : Fix datesDisabled
                });

                $("#datepicker" + uniq).change(function() {
                    $(this)[0].dispatchEvent(new Event('input'));
                });
            }, 250)
        },
        deleteDateRow: function (index) {
            this.dates.splice(index, 1)

            this.setDisabledDates()
        },
        // Objects
        addObject: function(object = null) {
            if(object != null){
                this.objects.push({
                    start_time: object.start_time ? object.start_time : (this.allowStartTime ? '' : '00:00'),
                    duration: object.duration ? object.duration : '',
                    route: object.route ? object.route : '00:00',
                    night: object.night ? object.night : '00:00',
                })
            } else {
                this.objects.push({
                    start_time: this.checking.inspection != null && this.checking.inspection.start_time ? this.checking.inspection.start_time : '00:00',
                    duration: this.checking.inspection != null && this.checking.inspection.duration ? this.checking.inspection.duration : '',
                    route:  this.checking.inspection != null && this.checking.inspection.route ? this.checking.inspection.route : '00:00',
                    night: this.checking.inspection != null && this.checking.inspection.night ? this.checking.inspection.night : '00:00',
                });
            }
        },
    },
    async mounted(){
         $("#userSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.usersRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedUsersId().join(';'), 'under_contract' : this.canSelectAllUsers == 0 ? 1 : 0 },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.fullname,
                                    value: item.fullname
                                })
                            }))
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.user = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addUserRow(item.item)
                        $(e.target).val("")
                        this.user = null
                    }
                }
            }).focus(() => {
                $("#userSearchInput").autocomplete("search", '');
            });

            const jsonDataBackup = JSON.parse(this.oldData)
            var jsonData = null

            if (Array.isArray(jsonDataBackup)) {
                jsonData = JSON.parse(this.initialData)
            } else {
                jsonData = jsonDataBackup
            }

            this.day = jsonData.day
            this.description = jsonData.description
            this.currentInspection = JSON.parse(this.inspection);

            if (jsonData.dates && Array.isArray(jsonData.dates)) {
                jsonData.dates.forEach((date) => {
                    this.addDate(date)
                })
            }

            if (jsonData.users && Array.isArray(jsonData.users)) {
                jsonData.users.forEach((user) => {
                    this.addUserRow(user)
                })
            }

             if (jsonData.objects && Array.isArray(jsonData.objects)) {
                jsonData.objects.forEach((object) => {
                    this.addObject(object);
                })
            } else {
                this.addObject();
            }
    }
}
</script>
